export const Confirm = {
  template: "#confirm"
};
